module.exports = __webpack_public_path__ + "img/selected3-min.e4b7c310.png";